import { render, staticRenderFns } from "./priority_badge.vue?vue&type=template&id=9b1fcebc&"
import script from "./priority_badge.vue?vue&type=script&lang=js&"
export * from "./priority_badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports